
import './ListingLayout.css';

const ListingLayout = ({
  paginatedData,
  numPostsToShow,
  showImgToggler,
  showPostTitle,
  showMeta,
  showContent,
  contentType,
  truncateContent,
  wordsLimit,
  imageUrl,
  valueForWidth,
  widthPercentage,
  widthController,
  ImgWidth,
  height,
  rowGap,
  ReadMoreBgColor,
  showReadMoreToggler,
  ReadMoreTextColor,
  button_Top_bottom_Padding,
  button_Right_Left_Padding,
  title_font_size,
  Meta_font_size,
  Content_font_size,
  Read_more_font_size,
  customCSS,
  Content_Manage_styling,
  Meta_Manage_styling,
  title_Manage_styling,
  ReadMoreText,
  __, // Placeholder for translation function
}) => {
  const Listing = paginatedData.slice(0, numPostsToShow);

  return (
    <div className='listing-layout'>
      {/* Inject custom CSS when Apply button is clicked */}
      {customCSS && <style>{customCSS}</style>}
      {Listing.map((item) => {
        const formattedDate = new Date(item?.date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });

        let featuredImgExist = false;
        if (item.hasOwnProperty("featured_image_url")) {
          const featuredImageUrlObj = item.featured_image_url;
          if (
            featuredImageUrlObj &&
            typeof featuredImageUrlObj === "object" &&
            Object.keys(featuredImageUrlObj).length > 0
          ) {
            featuredImgExist = true;
          }
        }

        return (
          <div key={item.id} className='post-container' style={{ marginBottom: rowGap }} >
            {showImgToggler && item?.featured_image_url && featuredImgExist && (
              <div className='image-container'>
                <img
                  className='block-image'
                  src={item.featured_image_url[imageUrl]}
                  style={{
                    ...(valueForWidth
                      ? { maxWidth: widthPercentage, maxHeight: widthPercentage }
                      : {
                        maxWidth: widthController === true ? ImgWidth : '',
                        maxHeight: widthController === true ? height : '',
                      }),
                  }}
                  alt={item.title.rendered} // Added alt text for accessibility
                />
              </div>
            )}
            {showPostTitle && (
              <div className='post-title'    style={{
                ...(title_Manage_styling && {
                  fontSize: title_font_size,
                })
              }}>
                <a
                  className='title'
                  href={item.link}
                  dangerouslySetInnerHTML={{ __html: item?.title.rendered }}
                ></a>
              </div>
            )}

            {showMeta && (
              <div className='meta-data' style={{
                ...(Meta_Manage_styling && {
                  fontSize: Meta_font_size,
                })
              }}>
                <p>
                  {formattedDate && `${formattedDate} `}
                  {item.post_author && `| Author: ${item.post_author} `}
                  {item.assigned_categories && `| Categories: ${item.assigned_categories} `}
                </p>
              </div>
            )}

            {showContent && (
              <div
              style={{
                ...(Content_Manage_styling && {
                  fontSize: Content_font_size,
                })
              }}
                className='post-content'
                dangerouslySetInnerHTML={{
                  __html:
                    contentType === "Full-Post"
                      ? item?.content?.rendered
                      : !item?.excerpt?.rendered
                        ? truncateContent(item?.content?.rendered, wordsLimit)
                        : truncateContent(item?.excerpt?.rendered, wordsLimit),
                }}
              />
            )}

            <div className='read-more-btn'  >
              <a
                href={item.link}
                target="_blank"
                className='read-more-button'
                style={{
                  ...(showReadMoreToggler && {
                    backgroundColor: ReadMoreBgColor,
                    color: ReadMoreTextColor,
                    padding: `${button_Top_bottom_Padding} ${button_Right_Left_Padding}`, 
                    fontSize: Read_more_font_size,        
                  }),
                }}
                >
                  {__(ReadMoreText || 'Read More', "advanced-posts-listing")}
                
              </a>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ListingLayout;
